import { Trigger, TriggerColor, TriggerType } from 'modules/trigger/types'

export enum TriggerEndpointKeys {
  getAllTriggers = 'getAllTriggers',
  getTrigger = 'getTrigger'
}

export type TriggerResponse = Trigger[]

export interface SaveTriggerPayload {
  type: TriggerType,
  title: string,
  colorBackground: TriggerColor,
  toggleDuration: boolean,
  duration?: number,
  schedule: string,
  active: boolean,
  startedAt?: string,
  id?: string
}
